export default {
  // Navigation
  nav_home: 'خانه',
  nav_dashboard: 'داشبورد',
  nav_orders: 'سفارشات',
  nav_wallet: 'کیف پول',
  nav_analytics: 'تحلیل‌ها',
  nav_referral: 'زیرمجموعه‌گیری',
  nav_account: 'حساب کاربری',
  nav_notifications: 'اعلان‌ها',
  nav_logout: 'خروج',
  nav_login: 'ورود',
  nav_signup: 'ثبت‌نام',
  nav_deposit_requests: 'درخواست‌های واریز',
  nav_withdraw_requests: 'درخواست‌های برداشت',
  nav_support_ticket: 'تیکت پشتیبانی',
  nav_system_logs: 'لاگ‌های سیستم',
  nav_announcements: 'اطلاعیه‌ها',
  nav_activity_logs: 'لاگ‌های فعالیت',
  nav_settings: 'تنظیمات',
  nav_section_main: 'اصلی',
  nav_user_active: 'اکنون فعال',
  nav_more: 'بیشتر',
  nav_logout_confirm: 'آیا مایل به خروج هستید؟',
  nav_language: 'زبان',

  // Dashboard
  dashboard_welcome: 'خوش آمدید',
  dashboard_total_earnings: 'کل درآمد',
  dashboard_pending_orders: 'سفارشات در انتظار',
  dashboard_completed_orders: 'سفارشات تکمیل شده',
  dashboard_commission_rate: 'نرخ کمیسیون',
  dashboard_quick_actions: 'دسترسی سریع',
  dashboard_recent_orders: 'سفارشات اخیر',
  dashboard_recent_activity: 'فعالیت‌های اخیر',
  dashboard_wallet_balance: 'موجودی کیف پول',
  dashboard_deposit: 'واریز',
  dashboard_withdraw: 'برداشت',
  dashboard_view_all: 'مشاهده همه',
  greeting_morning: 'صبح بخیر',
  greeting_afternoon: 'بعد از ظهر بخیر',
  greeting_evening: 'عصر بخیر',
  dashboard_greeting_desc: 'درآمد خود را پیگیری کنید، سفارشات را تکمیل کنید و حساب خود را در یک جا مدیریت کنید. مسیر موفقیت شما از اینجا ادامه می‌یابد!',

  // Dashboard Stats
  stats_available_balance: 'موجودی قابل دسترس',
  stats_total_withdrawn: 'کل برداشت شده',
  stats_total_deposit: 'کل واریز شده',
  stats_pending_orders: 'سفارشات در انتظار',
  stats_orders_suffix: ' سفارش',
  stats_task_earnings: 'درآمد از وظایف',
  stats_lifetime_earning: 'کل درآمد همیشگی',

  // Orders
  orders_title: 'سفارشات من',
  orders_all: 'همه سفارشات',
  orders_pending: 'در انتظار',
  orders_completed: 'تکمیل شده',
  orders_cancelled: 'لغو شده',
  orders_order_id: 'شناسه سفارش',
  orders_platform: 'پلتفرم',
  orders_amount: 'مبلغ',
  orders_commission: 'کمیسیون',
  orders_status: 'وضعیت',
  orders_date: 'تاریخ',
  orders_no_orders: 'سفارشی یافت نشد',

  // Wallet
  wallet_title: 'کیف پول من',
  wallet_available_balance: 'موجودی قابل دسترس',
  wallet_pending_balance: 'موجودی در انتظار',
  wallet_total_withdrawn: 'کل برداشت شده',
  wallet_deposit_now: 'واریز آنی',
  wallet_withdraw_now: 'برداشت آنی',
  wallet_transaction_history: 'تاریخچه تراکنش‌ها',
  wallet_deposit_history: 'تاریخچه واریزها',
  wallet_withdrawal_history: 'تاریخچه برداشت‌ها',
  wallet_deposit_desc: "با استفاده از روش‌های پرداخت موجود به کیف پول خود پول اضافه کنید.",
  wallet_no_deposits: "هیچ واریزی یافت نشد.",
  wallet_withdraw_history: "تاریخچه برداشت",
  wallet_withdraw_desc: "از کیف پول خود پول برداشت کنید.",
  wallet_no_withdrawals: "هیچ برداشتی یافت نشد.",
  wallet_no_withdrawals_desc: "شما هنوز هیچ برداشتی انجام نداده‌اید.",

  // Analytics
  analytics_title: 'تحلیل‌ها',
  analytics_earnings_overview: 'نمای کلی درآمد',
  analytics_platform_breakdown: 'تفکیک پلتفرم‌ها',
  analytics_performance_metrics: 'شاخص‌های عملکرد',
  analytics_top_products: 'محصولات برتر',
  analytics_this_month: 'این ماه',
  analytics_last_month: 'ماه گذشته',
  analytics_total_revenue: 'کل درآمد',
  analytics_avg_order_value: 'میانگین ارزش سفارش',

  // Referral
  referral_title: 'برنامه زیرمجموعه‌گیری',
  referral_your_code: 'کد معرفی شما',
  referral_copy_code: 'کپی کد',
  referral_share_link: 'اشتراک‌گذاری لینک',
  referral_total_referrals: 'کل معرفی‌ها',
  referral_active_referrals: 'معرفی‌های فعال',
  referral_referral_earnings: 'درآمد از معرفی',
  referral_invite_friends: 'دعوت از دوستان',

  // Account
  account_title: 'تنظیمات حساب',
  account_profile: 'پروفایل',
  account_security: 'امنیت',
  account_notifications: 'اعلان‌ها',
  account_kyc: 'احراز هویت KYC',
  account_phone: 'شماره تلفن',
  account_two_factor: 'تایید دو مرحله‌ای',
  account_save_changes: 'ذخیره تغییرات',
  account_cancel: 'لغو',

  // Auth & Common
  auth_email: 'ایمیل',
  auth_password: 'رمز عبور',
  auth_confirm_password: 'تایید رمز عبور',
  auth_forgot_password: 'رمز عبور را فراموش کرده‌اید؟',
  auth_remember_me: 'مرا به خاطر بسپار',
  auth_login_button: 'ورود',
  auth_signup_button: 'ثبت‌نام',
  auth_already_have_account: 'قبلاً ثبت‌نام کرده‌اید؟',
  auth_dont_have_account: "حساب کاربری ندارید؟",
  auth_reset_password: 'بازیابی رمز عبور',
  auth_verify_email: 'تایید ایمیل',
  auth_live_platform: 'پلتفرم زنده',
  auth_security_verification: 'تایید امنیتی',
  auth_captcha_refresh: 'بارگذاری مجدد',
  auth_captcha_placeholder: 'پاسخ',
  auth_captcha_error: 'جمع اشتباه است، دوباره تلاش کنید',
  auth_branding_title: 'تبدیل تبلیغات به',
  auth_branding_highlight_prefix: '',
  auth_branding_highlight: 'درآمد واقعی',
  auth_branding_desc: 'به هزاران تبلیغ‌کننده‌ای بپیوندید که روزانه از معتبرترین برندهای تجارت الکترونیک جهان کمیسیون دریافت می‌کنند.',
  auth_sign_in_to_account: 'وارد حساب کاربری {{system_name}} خود شوید',
  auth_email_placeholder: 'you@example.com',
  auth_password_placeholder: 'رمز عبور خود را وارد کنید',
  auth_signing_in: 'در حال ورود...',
  auth_free_to_join: 'عضویت رایگان است',
  auth_signup_branding_title: 'کسب درآمد را شروع کنید',
  auth_signup_branding_highlight: 'از اولین روز',
  auth_signup_branding_desc: 'هیچ تجربه‌ای نیاز نیست. در ۲ دقیقه ثبت‌نام کنید و انجام وظایف برای برندهای برتر تجارت الکترونیک را آغاز کنید.',
  auth_how_it_works: 'نحوه کارکرد',
  auth_signup_desc: 'به {{system_name}} بپیوندید و از همین امروز کسب کمیسیون را آغاز کنید — رایگان است!',
  auth_step_1: 'ایجاد حساب کاربری رایگان',
  auth_step_2: 'مشاهده و پذیرش وظایف',
  auth_step_3: 'تکمیل و دریافت کمیسیون',
  auth_signup_step_1_title: 'ایجاد حساب',
  auth_signup_step_1_desc: 'سفر خود را آغاز کنید',
  auth_signup_step_2_title: 'تکمیل وظایف',
  auth_signup_step_2_desc: 'دریافت کمیسیون روزانه',
  auth_signup_step_3_title: 'برداشت موجودی',
  auth_signup_step_3_desc: 'پرداخت‌های سریع و ایمن',
  auth_benefit_1_title: 'ایمن و قابل اعتماد',
  auth_benefit_1_desc: 'امنیت در سطح بانکی برای درآمدهای شما',
  auth_benefit_2_title: 'پرداخت‌های آنی',
  auth_benefit_2_desc: 'برداشت درآمد در کمتر از ۲۴ ساعت',
  auth_benefit_3_title: 'جامعه جهانی',
  auth_benefit_3_desc: 'به بیش از ۱۲,۰۰۰ تبلیغ‌کننده فعال بپیوندید',
  auth_benefit_4_title: 'پشتیبانی ۲۴/۷',
  auth_benefit_4_desc: 'هر زمان که نیاز داشتید کمک بگیرید',
  auth_strength_weak: 'ضعیف',
  auth_strength_fair: 'متوسط',
  auth_strength_good: 'خوب',
  auth_strength_strong: 'قوی',
  auth_password_strength: 'قدرت رمز عبور: {{strength}}',
  auth_social_proof: 'به بیش از {{count}} کسب‌کننده درآمد بپیوندید',
  auth_passwords_match: 'رمزهای عبور همخوانی دارند',
  auth_creating_account: 'در حال ایجاد حساب...',
  auth_phone_number: 'شماره تلفن',
  auth_phone_optional: '(اختیاری)',
  auth_phone_placeholder: 'شماره تلفن شما',
  auth_full_name: 'نام کامل',
  auth_full_name_placeholder: 'نام و نام خانوادگی',
  auth_password_min_chars: 'حداقل ۸ کاراکتر',
  auth_confirm_password_placeholder: 'تکرار رمز عبور',
  auth_agree_to: 'من با',
  auth_terms_of_service: 'شرایط خدمات',
  auth_privacy_policy: 'سیاست حریم خصوصی',
  auth_and: 'و',
  auth_create_free_account: 'ایجاد حساب رایگان',

  common_loading: 'در حال بارگذاری...',
  common_save: 'ذخیره',
  common_cancel: 'لغو',
  common_delete: 'حذف',
  common_edit: 'ویرایش',
  common_view: 'مشاهده',
  common_search: 'جستجو',
  common_filter: 'فیلتر',
  common_export: 'خروجی',
  common_import: 'ورودی',
  common_submit: 'ارسال',
  common_close: 'بستن',
  common_confirm: 'تایید',
  common_success: 'موفقیت',
  common_error: 'خطا',
  common_warning: 'هشدار',
  common_announcement: 'اطلاعیه',

  val_full_name_required: 'وارد کردن نام کامل الزامی است',
  val_email_required: 'وارد کردن ایمیل الزامی است',
  val_password_required: 'وارد کردن رمز عبور الزامی است',
  val_password_min: 'رمز عبور باید حداقل ۸ کاراکتر باشد',
  val_password_match_err: 'رمزهای عبور مطابقت ندارند.',
  security_pin_6_err: 'پین باید دقیقاً ۶ رقم باشد.',
  security_pin_digit_err: 'پین باید فقط شامل اعداد باشد.',

  // Settings
  settings_page_title: 'تنظیمات',
  settings_page_desc: 'امنیت، حریم خصوصی و ترجیحات خود را مدیریت کنید',
  settings_kyc_label: 'تأیید KYC',
  settings_kyc_desc: 'تأیید هویت',
  settings_security_label: 'امنیت',
  settings_security_desc: 'مدیریت رمز عبور',
  settings_language_label: 'زبان',
  settings_language_desc: 'ترجیحات منطقه‌ای',

  // Support
  support_btn_send: 'ارسال پاسخ',
  support_edit_message: 'ویرایش پیام',
  support_delete_message: 'حذف پیام',
  support_delete_confirm: 'آیا از حذف این پیام مطمئن هستید؟',
  support_message_updated: 'پیام با موفقیت بروزرسانی شد',
  support_message_deleted: 'پیام با موفقیت حذف شد',
  support_err_already_read: 'پس از مشاهده پیام، امکان ویرایش آن وجود ندارد.',

  val_agree_terms: 'شما باید شرایط را بپذیرید',
  val_conn_error: 'خطای اتصال. لطفاً دوباره تلاش کنید.',

  // Homepage
  home_hero_title: 'از برترین پلتفرم‌های تجارت الکترونیک کمیسیون دریافت کنید',
  home_hero_subtitle: 'به هزاران کاربری بپیوندید که روزانه از آمازون، علی‌بابا و علی‌اکسپرس کمیسیون دریافت می‌کنند',
  home_get_started: 'همین حالا شروع کنید',
  home_learn_more: 'اطلاعات بیشتر',
  home_how_it_works: 'نحوه کارکرد',
  home_features: 'ویژگی‌ها',
  home_why_choose_us: 'چرا ما؟',
  home_features_title: 'ویژگی‌های قدرتمند',
  home_features_subtitle: 'هر آنچه برای شروع کسب درآمد آنلاین نیاز دارید. طراحی شده با در نظر گرفتن موفقیت شما.',
  home_commission_tiers: 'سطوح کمیسیون',
  home_testimonials: 'نظرات کاربران ما',
  home_faq: 'سوالات متداول',
  home_cta_title: 'آماده شروع کسب درآمد هستید؟',
  home_cta_subtitle: 'همین امروز به جامعه ما بپیوندید و شروع به دریافت کمیسیون کنید',
  home_trusted_partner: 'پلتفرم‌های شریک معتبر',
  home_secure_platform: 'پلتفرم ایمن',
  home_instant_payouts: 'پرداخت‌های آنی',
  home_active_users: 'کاربران فعال',
  home_paid_out: 'پرداختی به کاربران',
  home_total_paid_out: 'کل مبلغ پرداختی',
  home_user_rating: 'امتیاز کاربران',
  home_countries: 'کشورها',
  home_commission_badge: 'پتانسیل درآمد',
  home_commission_title: 'نرخ‌های کمیسیون',
  home_commission_desc: 'موجودی بالاتر باعث باز شدن نرخ‌های کمیسیون بهتر می‌شود. در هر جلسه دقیقاً ۲۵ سفارش اختصاص داده می‌شود — تا ۴ جلسه در روز برای حداکثر درآمد انجام دهید.',
  home_tier_popular: 'محبوب‌ترین',
  home_tier_commission_per_order: 'کمیسیون در هر سفارش',
  home_tier_earn_examples: 'نمونه‌های درآمد:',
  home_tier_order: 'سفارش',
  home_tier_batch_earn: 'درآمد در هر دسته ۲۵تایی سفارش:',
  home_tier_daily_potential: 'پتانسیل روزانه (۴ دسته × ۲۵ سفارش)',
  home_tier_max_daily: 'تا ۱۰۰ سفارش در روز',
  home_tier_benefit_1: '۲۵ سفارش در هر دسته',
  home_tier_benefit_2: 'حداکثر ۴ دسته در روز',
  home_tier_benefit_3: 'واریز آنی کمیسیون',
  home_tier_above: 'بالای',
  home_tier_no_tiers: 'هیچ سطح کمیسیونی یافت نشد.',

  // Comparison Section
  home_compare_badge: 'تفاوت ما',
  home_compare_title: 'چرا ما بهتر هستیم؟',
  home_compare_subtitle: 'پلتفرم ما را با کارهای پاره‌وقت سنتی مقایسه کنید و ببینید چرا هزاران نفر ما را انتخاب می‌کنند.',
  home_compare_feature: 'ویژگی',
  home_compare_traditional: 'کارهای سنتی',
  home_compare_our_platform: 'پلتفرم ما',
  home_compare_f1: 'انعطاف‌پذیری',
  home_compare_f1_trad: 'ساعات کاری ثابت',
  home_compare_f1_our: 'کار در هر زمان و هر مکان',
  home_compare_f2: 'پرداخت‌ها',
  home_compare_f2_trad: 'ماهانه یا دو هفته یکبار',
  home_compare_f2_our: 'آنی / در همان روز',
  home_compare_f3: 'پیش‌نیازها',
  home_compare_f3_trad: 'تجربه/رزومه/مصاحبه',
  home_compare_f3_our: 'هیچ — فقط یک گوشی هوشمند',
  home_compare_f4: 'پیشرفت',
  home_compare_f4_trad: 'افزایش سالانه ثابت',
  home_compare_f4_our: 'رشد نامحدود بر اساس سطوح',

  // Testimonials
  home_testi_badge: 'داستان‌های موفقیت',
  home_testi_title: 'مورد اعتماد هزاران نفر',
  home_testi_subtitle: 'از جامعه جهانی تبلیغ‌کنندگان ما بشنوید که درآمد خود را متحول کرده‌اند.',
  home_testi_no_stories: 'هنوز داستان موفقیتی در دسترس نیست.',
  home_testi_total_earned: 'کل درآمد',
  home_testi_time_period: 'بازه زمانی',
  home_testi_verified: 'کاربر تایید شده',
  home_testi_avg_rating: 'میانگین امتیاز',
  home_testi_satisfaction_rate: 'نرخ رضایت',
  home_testi_support_available: 'پشتیبانی در دسترس',

  // FAQ
  home_faq_badge: 'پشتیبانی',
  home_faq_title: 'سوالات رایج',
  home_faq_subtitle: 'هر آنچه باید در مورد شروع و کسب درآمد بدانید.',
  home_faq_no_data: 'سوالی یافت نشد.',

  // Trust Bar
  home_trust_badge: 'اعتماد جهانی',
  home_trust_title: 'مورد اعتماد برندهای پیشرو',
  home_trust_desc: 'ما با بزرگترین پلتفرم‌های تجارت الکترونیک جهان همکاری می‌کنیم تا خدمات تبلیغاتی تایید شده ارائه دهیم.',

  // Feature Section
  feature_1_title: 'پرداخت‌های آنی',
  feature_1_desc: 'بلافاصله پس از تکمیل سفارش، درآمد خود را دریافت کنید. هر زمان که خواستید بدون تاخیر برداشت کنید.',
  feature_1_detail_1: 'واریز کمیسیون به صورت آنی',
  feature_1_detail_2: 'گزینه‌های مختلف برداشت',
  feature_1_detail_3: 'بدون حداقل موجودی برای برداشت',
  feature_2_title: 'پلتفرم ایمن',
  feature_2_desc: 'رمزنگاری در سطح بانکی از داده‌ها و درآمدهای شما محافظت می‌کند. مورد اعتماد هزاران کاربر در سراسر جهان.',
  feature_2_detail_1: 'رمزنگاری SSL فعال',
  feature_2_detail_2: 'تایید دو مرحله‌ای',
  feature_2_detail_3: 'بازرسی‌های امنیتی منظم',
  feature_2_detail_4: 'تضمین حریم خصوصی داده‌ها',
  feature_3_title: 'ساعات کاری منعطف',
  feature_3_desc: 'هر زمان که می‌خواهید، هر کجا که هستید کار کنید. بدون برنامه ثابت، سفارش‌ها را با سرعت خودتان تکمیل کنید.',
  feature_3_detail_1: 'بدون ساعات کاری ثابت',
  feature_3_detail_2: 'امکان کار از هر کجای دنیا',
  feature_3_detail_3: 'سرعت کار به انتخاب شما',
  feature_3_detail_4: 'فعالیت در روزهای تعطیل',
  feature_4_title: 'درآمد فزاینده',
  feature_4_desc: 'با تکمیل سفارشات بیشتر، نرخ‌های کمیسیون بالاتری را باز کنید. با هر ارتقای سطح، درآمد خود را افزایش دهید.',
  feature_4_detail_1: 'نرخ کمیسیون بر اساس سطح',
  feature_4_detail_2: 'ارتقای خودکار سطح کاربری',
  feature_4_detail_3: 'پاداش‌های عملکردی',
  feature_5_title: 'پلتفرم جهانی',
  feature_5_desc: 'با برندهای بین‌المللی از هر کجای جهان کار کنید. پشتیبانی از ارزهای مختلف فراهم شده است.',
  feature_5_detail_1: 'در دسترس در سراسر جهان',
  feature_5_detail_2: 'پشتیبانی از ارزهای مختلف',
  feature_5_detail_3: 'روش‌های پرداخت محلی',
  feature_6_title: 'پشتیبانی ۲۴/۷',
  feature_6_desc: 'تیم پشتیبانی اختصاصی ما همیشه آماده کمک است. از طریق چت زنده، ایمیل یا تلفن راهنمایی بگیرید.',
  feature_6_detail_1: 'چت زنده در دسترس است',
  feature_6_detail_2: 'پشتیبانی ایمیل ۲۴/۷',
  feature_6_detail_3: 'راهنمایی تلفنی',
  feature_6_detail_4: 'سوالات متداول جامع',
  feature_7_title: 'برنامه زیرمجموعه‌گیری',
  feature_7_desc: 'با دعوت از دوستان درآمد اضافی کسب کنید. از درآمد زیرمجموعه‌های خود کمیسیون همیشگی دریافت کنید.',
  feature_7_detail_1: 'درآمد زیرمجموعه‌گیری همیشگی',
  feature_7_detail_2: 'زیرمجموعه نامحدود',
  feature_7_detail_3: 'ابزارهای اشتراک‌گذاری آسان',
  feature_7_detail_4: 'پاداش‌های تشویقی',
  feature_8_title: 'پشتیبانی از چندین ارز',
  feature_8_desc: 'پشتیبانی از ارزهای اصلی و روش‌های پرداخت. روشی را که برای شما بهتر است انتخاب کنید.',
  feature_8_detail_1: 'پشتیبانی از USD، EUR، GBP',
  feature_8_detail_2: 'حواله بانکی در دسترس است',
  feature_8_detail_3: 'یکپارچه‌سازی با کیف پول‌های الکترونیکی',
  feature_8_detail_4: 'گزینه‌های کریپتو به زودی',
  feature_9_title: 'اعلان‌های آنی',
  feature_9_desc: 'با هشدارهای لحظه‌ای برای سفارش‌های جدید، درآمدها و فعالیت‌های حساب به‌روز بمانید.',
  feature_9_detail_1: 'اعلان‌های ارسالی (Push)',
  feature_9_detail_2: 'هشدارهای ایمیلی',
  feature_9_detail_3: 'به‌روزرسانی‌های پیامکی',
  feature_9_detail_4: 'پیام‌های درون‌برنامه',

  // Home Page Additional Sections
  home_how_it_works_badge: 'فرآیند ساده',
  home_how_it_works_title: 'نحوه کارکرد',
  home_how_it_works_subtitle: 'کسب درآمد را در ۴ مرحله ساده شروع کنید. هیچ تجربه‌ای لازم نیست، فقط فرآیند را دنبال کنید و شاهد رشد درآمد خود باشید.',
  home_cta_ready_title: 'آماده شروع سفر خود هستید؟',
  home_cta_ready_desc: 'به هزاران کاربری بپیوندید که هم‌اکنون روزانه درآمد دارند. اولین کمیسیون شما فقط چند دقیقه با شما فاصله دارد!',
  home_cta_avg_time: 'میانگین زمان تا اولین درآمد:',
  home_cta_15_mins: '۱۵ دقیقه',
  home_cta_new_users: 'کاربران جدید امروز:',

  // CTA Section (Premium)
  home_cta_limit_spots: 'ظرفیت محدود برای این ماه',
  home_cta_main_title: 'کسب درآمد واقعی را آغاز کنید',
  home_cta_today: 'همین امروز!',
  home_cta_main_desc: 'به هزاران کاربری بپیوندید که روزانه کمیسیون دریافت می‌کنند. بدون نیاز به تجربه، ساعات کاری منعطف، پرداخت‌های آنی. آزادی مالی شما از اینجا شروع می‌شود.',
  home_cta_spots_remaining: 'ظرفیت باقی‌مانده',
  home_cta_new_users_today: 'کاربران جدید امروز',
  home_cta_create_account: 'ایجاد حساب کاربری رایگان',
  home_cta_sign_in: 'ورود به حساب',
  home_cta_secure: '۱۰۰٪ ایمن',
  home_cta_payouts: 'برداشت در ۲۴-۴۸ ساعت',
  home_cta_rating: 'امتیاز ۴.۹ از ۵',
  home_cta_active_users: 'کاربران فعال',
  home_cta_total_paid: 'کل مبالغ پرداختی',
  home_cta_orders_done: 'سفارشات انجام شده',
  home_cta_satisfaction: 'میزان رضایت',
  home_cta_guarantee_title: 'ضمانت بازگشت وجه',
  home_cta_guarantee_desc: 'راضی نیستید؟ مبلغ واریزی خود را ظرف ۷ روز پس بگیرید',

  // Footer Branding & Extras
  footer_brand_desc: 'پلتفرم پیشرو در ترویج تجارت الکترونیک در جهان. امروز به شبکه جهانی ما بپیوندید و شروع به دریافت کمیسیون از برترین برندها کنید.',
  footer_ssl_secure: 'امنیت SSL',
  footer_aes_256: 'رمزنگاری AES-256',
  footer_cookie_policy: 'سیاست کوکی',
  footer_disclaimer: 'سلب مسئولیت',
  footer_all_rights: 'تمامی حقوق محفوظ است.',

  // Announcements
  announcement_withdrawal_delay_title: 'تاخیر در پردازش برداشت‌ها',
  announcement_withdrawal_delay_summary: 'برداشت‌ها ممکن است به دلیل حجم بالای درخواست‌ها تا ۷۲ ساعت زمان ببرند. لطفاً برنامه‌ریزی کنید.',
  announcement_date_june_14: '۱۴ ژوئن ۲۰۲۵',

  // How It Works Steps
  step_1_title: 'ثبت‌نام',
  step_1_desc: 'ایجاد حساب کاربری کمتر از ۲ دقیقه زمان می‌برد.',
  step_1_detail_1: 'اطلاعات اولیه خود را وارد کنید',
  step_1_detail_2: 'آدرس ایمیل خود را تایید کنید',
  step_1_detail_3: 'امنیت حساب خود را تامین کنید',
  step_1_detail_4: 'دسترسی آنی به داشبورد',
  step_2_title: 'انتخاب وظیفه',
  step_2_desc: 'از میان وظایف تبلیغاتی موجود انتخاب کنید.',
  step_2_detail_1: 'فیلتر بر اساس پلتفرم',
  step_2_detail_2: 'مشاهده نرخ‌های کمیسیون',
  step_2_detail_3: 'پذیرش چندین وظیفه',
  step_2_detail_4: 'به‌روزرسانی آنی وظایف',
  step_3_title: 'تکمیل وظیفه',
  step_3_desc: 'وظایف را طبق دستورالعمل انجام دهید.',
  step_3_detail_1: 'دستورالعمل‌های بسیار ساده',
  step_3_detail_2: 'ارسال سریع وظایف انجام شده',
  step_3_detail_3: 'تایید خودکار سیستم',
  step_3_detail_4: 'رابط کاربری مناسب موبایل',
  step_4_title: 'درآمد و برداشت',
  step_4_desc: 'برای هر وظیفه تکمیل شده دستمزد بگیرید.',
  step_4_detail_1: 'پیگیری آنی درآمدها',
  step_4_detail_2: 'حداقل مبلغ بسیار کم برای برداشت',
  step_4_detail_3: 'روش‌های پرداخت متنوع',
  step_4_detail_4: 'پشتیبانی برداشت ۲۴/۷',

  // Redesigned Footer
  footer_stay_loop_title: 'در جریان باشید',
  footer_stay_loop_desc: 'آخرین به‌روزرسانی‌ها، نکات و پیشنهادهای انحصاری را مستقیماً در اینباکس خود دریافت کنید.',
  footer_subscribe: 'اشتراک',
  footer_subscribe_placeholder: 'آدرس ایمیل خود را وارد کنید',
  footer_trusted_secure: 'قابل اعتماد و امن:',
  footer_ssl_secured: 'امنیت SSL',
  footer_ssl_secured_desc: 'SSL ۲۵۶ بیتی',
  footer_aes_encryption: 'رمزگذاری AES-256',
  footer_aes_encryption_desc: 'در سطح بانکی',
  footer_kyc_compliant: 'سازگار با KYC',
  footer_kyc_compliant_desc: 'تایید شده',
  footer_gdpr_compliant: 'سازگار با GDPR',
  footer_gdpr_compliant_desc: 'داده‌ها محافظت شده',
  footer_iso_certified: 'ISO 27001',
  footer_iso_certified_desc: 'دارای گواهینامه',
  footer_platform: 'پلتفرم',
  footer_support: 'پشتیبانی',
  footer_legal: 'قانونی',
  footer_help_center: 'مرکز راهنمایی',
  footer_contact_us: 'تماس با ما',
  footer_payments_label: 'پرداخت‌ها:',
  home_live_activity_title: 'فعالیت زنده پلتفرم',
  home_recent_activity_title: 'فعالیت‌های اخیر',
  home_total_commissions_paid: 'مجموع کمیسیون‌های پرداخت شده',
  home_active_users_online: 'کاربران فعال آنلاین',
  home_tasks_completed_today: 'وظایف انجام شده امروز',
  account_security_tips_title: 'توصیه‌های امنیتی',
  account_security_tips_desc: 'با دنبال کردن این اقدامات ساده، محافظت از حساب خود را بهبود بخشید.',
  tip_password_title: 'رمز عبور قوی',
  tip_password_desc: 'برای اطمینان از امنیت حساب خود، از ترکیبی از حروف، اعداد و نمادها استفاده کنید.',
  tip_two_factor_title: 'تایید هویت',
  tip_two_factor_desc: 'اطلاعات تماس خود را به روز نگه دارید تا اعلان‌های امنیتی مهم را دریافت کنید.',
  tip_logout_title: 'خروج منظم از حساب',
  tip_logout_desc: 'همیشه هنگام استفاده از کامپیوترهای عمومی یا مشترک، از حساب خود خارج شوید.',
  tip_sharing_title: 'هرگز دسترسی را به اشتراک نگذارید',
  tip_sharing_desc: 'تیم پشتیبانی ما هرگز رمز عبور شما را نخواهد پرسید. هرگز اطلاعات ورود خود را با کسی به اشتراک نگذارید.',

  // درخواست‌های سفارش
  order_requests_title: 'درخواست‌های سفارش',
  order_requests_desc: 'درخواستی برای یک کار جدید یا سفارش سفارشی ارسال کنید. مدیر درخواست شما را بررسی کرده و کارهایی را بر اساس آن اختصاص می‌دهد.',
  order_requests_new_btn: 'درخواست سفارش جدید',
  order_requests_table_id: 'شناسه درخواست',
  order_requests_table_data: 'جزئیات درخواست',
  order_requests_table_status: 'وضعیت',
  order_requests_table_date: 'ارسال شده در',
  order_requests_table_actions: 'عملیات',
  order_requests_cancel: 'لغو',
  order_requests_cancel_confirm: 'آیا مطمئن هستید که می‌خواهید این درخواست سفارش را لغو کنید؟',
  order_requests_cancel_success: 'درخواست سفارش با موفقیت لغو شد.',
  order_requests_create_success: 'درخواست سفارش با موفقیت ارسال شد.',
  order_requests_modal_title: 'ارسال درخواست سفارش جدید',
  order_requests_modal_desc: 'لطفاً اطلاعات دقیقی در مورد سفارشی که می‌خواهید درخواست کنید ارائه دهید.',
  order_requests_field_data: 'داده‌های درخواست سفارش',
  order_requests_field_placeholder: 'مثلاً: من می‌خواهم یک سفارش سفارشی برای بسته ممتاز درخواست کنم.',
  order_requests_btn_submit: 'ارسال درخواست',
  order_requests_btn_submitting: 'در حال ارسال...',
  order_requests_empty: 'هیچ درخواست سفارشی یافت نشد.',
  order_requests_status_pending: 'در انتظار',
  order_requests_status_approved: 'تأیید شده',
  order_requests_status_rejected: 'رد شده',
  order_requests_status_cancelled: 'لغو شده',
  order_requests_terms_title: 'شرایط الزام‌آور سفارش',
  order_requests_term_1: 'سفارشات جدید ظرف ۲۴ تا ۴۸ ساعت پس از تایید اختصاص داده می‌شوند.',
  order_requests_term_2: 'پس از انتشار، سفارشات قابل لغو، توقف یا تغییر نیستند.',
  order_requests_term_3: 'تمام سفارشات اختصاص داده شده باید قبل از برداشت تکمیل شوند.',
  order_requests_term_4: 'عدم تکمیل سفارشات ممکن است بر وضعیت حساب شما تأثیر بگذارد.',
  order_requests_term_5: 'این درخواست نهایی است و پس از ارسال قابل بازگشت نیست.',
  order_requests_policy_title: 'سیاست عدم لغو',
  order_requests_policy_desc: 'با ارسال این درخواست، شما تأیید می‌کنید که دسته سفارش جدید غیرقابل بازگشت است. پس از تأیید توسط سیستم ما، هیچ‌گونه لغو، تغییر یا بازپرداخت تحت هیچ شرایطی مجاز نخواهد بود.',
  order_requests_accept_terms: 'من شرایط فوق را خوانده‌ام و کاملاً درک می‌کنم. تایید می‌کنم که این درخواست سفارش پس از ارسال قابل لغو یا تغییر نیست و موافقت می‌کنم که تمام سفارشات اختصاص داده شده را تکمیل کنم.',

  // Orders Page (New Sections)
  orders_withdrawal_policy: 'سیاست برداشت',
  orders_unlock_req: 'الزامات بازگشایی',
  orders_unlock_desc: 'اولین دسته {{count}} تایی سفارش خود را تکمیل کنید تا برداشت‌ها برای همیشه باز شوند. این شرط یک‌باره امنیت پلتفرم را تضمین کرده و از سوءاستفاده جلوگیری می‌کند.',
  orders_daily_limits: 'محدودیت‌های روزانه سفارش',
  orders_daily_limit_1: '{{count}} سفارش در هر دسته — شما باید همه آن‌ها را قبل از درخواست دسته بعدی تکمیل کنید',
  orders_daily_limit_2: 'حداکثر {{count}} دسته در روز ({{total}} سفارش در روز)',
  orders_comm_rates: 'نرخ‌های کمیسیون',
  orders_comm_rates_desc: 'نرخ‌ها توسط پلتفرم و بر اساس موجودی فعلی کیف پول شما تعیین می‌شوند:',
  orders_payout_timeline: 'زمان‌بندی پرداخت',
  orders_payout_desc: 'برداشت‌ها ظرف ۲۴ تا ۴۸ ساعت پردازش می‌شوند. حواله‌های بانکی ممکن است ۳ تا ۵ روز کاری زمان ببرند. برداشت‌های کریپتو آنی هستند.',
  orders_processing_fee: 'کارمزد پردازش {{fee}}٪ برای تمامی برداشت‌ها جهت پوشش هزینه‌های تراکنش اعمال می‌شود.',
  orders_tips_title: 'نکاتی برای موفقیت',
  orders_tips_1: 'سفارشات را روزانه تکمیل کنید تا روند مداومی ایجاد کرده و درآمد خود را به حداکثر برسانید',
  orders_tips_2: 'هنگام پردازش سفارش در صفحه بمانید تا از تکمیل صحیح آن اطمینان حاصل کنید',
  orders_tips_3: 'کیف پول خود را به طور منظم چک کنید تا رشد کمیسیون‌های خود را پیگیری کنید',
  orders_tips_4: 'دوستان خود را معرفی کنید تا از سفارشات آن‌ها کمیسیون پاداش بگیرید',
  orders_tips_5: 'در صورت بروز هرگونه مشکل، بلافاصله با پشتیبانی تماس بگیرید',
  orders_batch_approx: '{{count}} سفارش در هر دسته × میانگین ${{avg}} = تقریباً ${{total}} در هر دسته',
};